// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4bdbed3f","732":"cf73b4ec","977":"f0de699d"}[chunkId] + ".chunk.js";
};